import { render, staticRenderFns } from "./OverView.vue?vue&type=template&id=2a46ae54&scoped=true&"
import script from "./OverView.vue?vue&type=script&lang=js&"
export * from "./OverView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46ae54",
  null
  
)

export default component.exports